import { Action } from '@ngrx/store';
import { Structure } from '../../models/app.model';

export const LOAD_ALL = '[STRUCTURE] Load All';
export const LOAD_SUCCESS = '[STRUCTURE] Load Success';
export const LOAD_FAIL = '[STRUCTURE] Load Failed';
export const UPDATE_DATA = '[STRUCTURE] Update Data';
export const UPDATE_DATA_FAIL = '[STRUCTURE] Update Data Fail';

export class LoadAll implements Action {
  readonly type = LOAD_ALL;
  constructor(public payload: Array<Structure> = []) { }
}

export class LoadSuccess implements Action {
  readonly type = LOAD_SUCCESS;
  constructor(public payload: any) { }
}

export class LoadFail implements Action {
  readonly type = LOAD_FAIL;
  constructor(public payload: any) { }
}

export class UpdateData implements Action {
  readonly type = UPDATE_DATA;
  constructor(public payload: Structure) { }
}

export class UpdateDataFail implements Action {
  readonly type = UPDATE_DATA_FAIL;
  constructor(public payload: any) { }
}

export type StructureAction = LoadAll  | LoadSuccess | LoadFail | UpdateData | UpdateDataFail;
